import { createAction, union, props } from '@ngrx/store';

export const setValue = createAction('PseudoLocalActions/Set', props<{ key: string; data: unknown }>());
export const destroyValue = createAction('PseudoLocalActions/Destroy', props<{ key: string }>());

const _all = union({ setValue, destroyValue });
export type PseudoLocalActionsUnion = typeof _all;
